export enum MessageType {
  ERROR,
  SUCCESS,
  INFO,
  WARNING,
  DEFAULT
}
